﻿// Diccionario estático en memoria (Fricción Cero)
const translations: Record<string, Record<string, string>> = {
    es: {
        // Navegación & Global
        "nav.retail": "Retail",
        "nav.store": "Catálogo",
        "nav.booking": "Reservas",
        "nav.elearning": "E-Learning",
        "nav.corporate": "Corporativo",
        "nav.erp": "ERP",
        "btn.cta": "Quiero esto",
        "btn.submit": "Solicitar Demo",
        "modal.title": "Inicia tu Plataforma",
        "modal.desc": "Déjanos tus datos y un arquitecto de ROMI.cl te contactará con una demo personalizada.",

        // Vista: Retail
        "retail.badge": "Headless Commerce",
        "retail.title": "Retail Óptimo",
        "retail.desc": "Descubrimiento de productos ultrarrápido. Sin tiempos de carga, solo renderizado instantáneo para mayor conversión.",
        "retail.card1.title": "Zapatillas Minimalistas",
        "retail.card1.desc": "Materiales transpirables para uso diario. Mira cómo las imágenes cargan al instante desde el Edge.",
        "retail.card2.title": "Silla Ergonómica",
        "retail.card2.desc": "Diseñada para el espacio de trabajo moderno. Interacciones fluidas sin recargar la página.",
        "retail.card3.title": "Audio Inalámbrico",
        "retail.card3.desc": "Sonido sin latencia en una interfaz que reacciona tan rápido como el producto.",

        // Vista: Corporate
        "corp.badge": "Plataforma B2B",
        "corp.title": "Nivel Enterprise",
        "corp.desc": "Tu presencia institucional debe transmitir confianza al instante. Tipografía limpia y rendimiento sólido.",
        "corp.card1.title": "Escalabilidad Global",
        "corp.card1.desc": "Despliega tus activos globalmente. Tu sitio carga en milisegundos, ya sea en Santiago, Nueva York o Tokio.",
        "corp.card2.title": "Seguridad Primero",
        "corp.card2.desc": "Protección DDoS y reglas de firewall a nivel de borde integradas en la arquitectura base.",
        "corp.card3.title": "Mantenimiento Cero",
        "corp.card3.desc": "Serverless significa sin parches, sin actualizaciones de servidor y 99.99% de tiempo de actividad garantizado.",

        // Vista: ERP
        "erp.badge": "Herramientas Internas",
        "erp.title": "Dashboard en Tiempo Real",
        "erp.desc": "Gestiona tus datos sin sobrecarga. Consulta tu base de datos D1 al instante sin saltos visuales.",
        "erp.card1.title": "Leads Totales",
        "erp.card1.sub": "+12% esta semana",
        "erp.card2.title": "Sesión Promedio",
        "erp.card2.sub": "De 300 usuarios activos",
        "erp.card3.title": "Carga del Servidor",
        "erp.card3.sub": "Arquitectura Serverless"
    },
    en: {
        // Navigation & Global
        "nav.retail": "Retail",
        "nav.store": "Store",
        "nav.booking": "Booking",
        "nav.elearning": "E-Learning",
        "nav.corporate": "Corporate",
        "nav.erp": "ERP",
        "btn.cta": "Get this",
        "btn.submit": "Request Demo",
        "modal.title": "Start your Platform",
        "modal.desc": "Leave your details and a ROMI.cl architect will contact you with a customized demo.",

        // View: Retail
        "retail.badge": "Headless Commerce",
        "retail.title": "Frictionless Retail",
        "retail.desc": "Ultra-fast product discovery. No loading spinners, just instant rendering for higher conversion rates.",
        "retail.card1.title": "Minimalist Sneakers",
        "retail.card1.desc": "Breathable materials crafted for daily use. See how images load instantly from the Edge.",
        "retail.card2.title": "Ergonomic Chair",
        "retail.card2.desc": "Designed for the modern workspace. Smooth Add-to-Cart interactions without page reloads.",
        "retail.card3.title": "Wireless Audio",
        "retail.card3.desc": "Experience latency-free sound, presented in a UI that reacts exactly as fast as the product.",

        // View: Corporate
        "corp.badge": "B2B Platform",
        "corp.title": "Enterprise Grade",
        "corp.desc": "Your institutional presence needs to convey trust instantly. Clean typography and solid performance.",
        "corp.card1.title": "Global Scalability",
        "corp.card1.desc": "Deploy your corporate assets globally. Your site loads in milliseconds, whether in Santiago, New York, or Tokyo.",
        "corp.card2.title": "Security First",
        "corp.card2.desc": "DDoS protection and edge-level firewall rules built into the core architecture.",
        "corp.card3.title": "Zero Maintenance",
        "corp.card3.desc": "Serverless means no patching, no server updates, and 99.99% uptime guaranteed.",

        // View: ERP
        "erp.badge": "Internal Tools",
        "erp.title": "Real-time Dashboard",
        "erp.desc": "Manage your data without the bloat. Instantly query your D1 database with zero layout shifts.",
        "erp.card1.title": "Total Leads",
        "erp.card1.sub": "+12% this week",
        "erp.card2.title": "Average Session",
        "erp.card2.sub": "From 300 active users",
        "erp.card3.title": "Server Load",
        "erp.card3.sub": "Serverless Architecture"
    },
    pt: {
        // Navegação & Global
        "nav.retail": "Varejo",
        "nav.store": "Catálogo",
        "nav.booking": "Reservas",
        "nav.elearning": "E-Learning",
        "nav.corporate": "Corporativo",
        "nav.erp": "ERP",
        "btn.cta": "Quero isso",
        "btn.submit": "Solicitar Demo",
        "modal.title": "Inicie sua Plataforma",
        "modal.desc": "Deixe seus dados e um arquiteto da ROMI.cl entrará em contato com uma demo personalizada.",

        // View: Retail
        "retail.badge": "Headless Commerce",
        "retail.title": "Varejo Sem Atrito",
        "retail.desc": "Descoberta de produtos ultrarrápida. Sem telas de carregamento, apenas renderização instantânea para maior conversão.",
        "retail.card1.title": "Tênis Minimalista",
        "retail.card1.desc": "Materiais respiráveis criados para uso diário. Veja como as imagens carregam instantaneamente.",
        "retail.card2.title": "Cadeira Ergonômica",
        "retail.card2.desc": "Projetada para o espaço de trabalho moderno. Interações fluidas sem recarregar a página.",
        "retail.card3.title": "Áudio Sem Fio",
        "retail.card3.desc": "Som sem latência em uma interface que reage tão rápido quanto o produto.",

        // View: Corporate
        "corp.badge": "Plataforma B2B",
        "corp.title": "Nível Enterprise",
        "corp.desc": "Sua presença institucional precisa transmitir confiança. Tipografia limpa e desempenho sólido.",
        "corp.card1.title": "Escalabilidade Global",
        "corp.card1.desc": "Implante seus ativos globalmente. Seu site carrega em milissegundos, seja em Santiago, Nova York ou Tóquio.",
        "corp.card2.title": "Segurança em Primeiro Lugar",
        "corp.card2.desc": "Proteção DDoS e regras de firewall integradas na arquitetura principal.",
        "corp.card3.title": "Manutenção Zero",
        "corp.card3.desc": "Serverless significa sem patches, sem atualizações de servidor e 99.99% de tempo de atividade.",

        // View: ERP
        "erp.badge": "Ferramentas Internas",
        "erp.title": "Dashboard em Tempo Real",
        "erp.desc": "Gerencie seus dados sem lentidão. Consulte seu banco D1 instantaneamente sem saltos visuais.",
        "erp.card1.title": "Leads Totais",
        "erp.card1.sub": "+12% esta semana",
        "erp.card2.title": "Sessão Média",
        "erp.card2.sub": "De 300 usuários ativos",
        "erp.card3.title": "Carga do Servidor",
        "erp.card3.sub": "Arquitetura Serverless"
    }
};
// (Mantén tus diccionarios 'translations' tal como los tenías)

// AQUÍ ESTÁ EL CAMBIO: Usar texto en lugar de Emojis que fallan en Windows
const flags: Record<string, string> = { es: 'ES', en: 'EN', pt: 'PT' };

export class I18nManager {
    public currentLang: string = 'es';

    constructor() {
        this.init();
    }

    private init() {
        const savedLang = localStorage.getItem('romi-lang');
        if (savedLang && translations[savedLang]) {
            this.currentLang = savedLang;
        }

        const toggleBtn = document.getElementById('lang-toggle');
        const dropdown = document.getElementById('lang-dropdown');
        const flagSpan = document.getElementById('current-lang-flag');

        toggleBtn?.addEventListener('click', () => dropdown?.classList.toggle('hidden'));

        document.addEventListener('click', (e) => {
            if (!toggleBtn?.contains(e.target as Node) && !dropdown?.contains(e.target as Node)) {
                dropdown?.classList.add('hidden');
            }
        });

        document.querySelectorAll('.lang-option').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const lang = (e.currentTarget as HTMLElement).dataset.lang;
                if (lang && translations[lang]) {
                    this.setLanguage(lang);
                    if (flagSpan) flagSpan.textContent = flags[lang];
                    dropdown?.classList.add('hidden');
                }
            });
        });

        if (flagSpan) flagSpan.textContent = flags[this.currentLang];
        this.translateDOM();
        window.addEventListener('viewInjected', () => this.translateDOM());
    }

    public setLanguage(lang: string) {
        this.currentLang = lang;
        localStorage.setItem('romi-lang', lang);
        this.translateDOM();
    }

    public translateDOM() {
        const elements = document.querySelectorAll('[data-i18n]');
        const dict = translations[this.currentLang];

        elements.forEach(el => {
            const key = el.getAttribute('data-i18n');
            if (key && dict[key]) {
                el.innerHTML = dict[key];
            }
        });
    }
}